import { PAGE_DEFAULT, ROW_DEFAULT } from 'constants/global';

export const EMPTY_DATA_SEARCH_DOCUMENT = {
    text_search: '',
    type_uuid: null,
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
};
